export const INSTACASH_ELIGIBILITY_STATUS = {
  QUALIFIED: 'ADDON_SUCCESS',
  TRIAL_TIER: 'INSTACASH_TRIAL_TIER',
}
